var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIos = function SvgShareIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.055 15.502-6.406-5.49-.65-.558-.651.558-6.405 5.49 1.301 1.518L19 12.945v8.806h2v-8.806l4.754 4.075 1.302-1.518Z",
    fill: "#0F74FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6",
    stroke: "#0F74FF",
    strokeWidth: 2
  })));
};
export default SvgShareIos;